import { render, staticRenderFns } from "./blog.page.vue?vue&type=template&id=33701170&scoped=true&"
import script from "./blog.page.vue?vue&type=script&lang=js&"
export * from "./blog.page.vue?vue&type=script&lang=js&"
import style0 from "./blog.page.vue?vue&type=style&index=0&id=33701170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33701170",
  null
  
)

export default component.exports